/**
 * Schermteksten in het Turks.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const tr: Teksten = {
  kamerOphalen: "Oda getiriliyor…",
  kamerWerktNiet: "Bu oda çalışmıyor",
  serverReageertNiet: "Sunucu yanıt vermiyor",
  probeerOpnieuw: "Tekrar dene",
  vraagNieuweCode: "Kodu paylaşan kişiden yeni bir kod iste. Odaların süresi birkaç saat sonra dolar.",
  welkeTaalSprekJij: "Hangi dili konuşuyorsun?",
  jouwStem: "Çevirideki ses tonun",
  man: "Erkek",
  vrouw: "Kadın",
  pincode: "PIN kodu",
  pincodeUitleg: "Bunu kodu paylaşan kişiden alabilirsin.",
  gaDeKamerIn: "Odaya gir",
  kiesEerstJeTaal: "Önce dilini seç",
  microfoonAanvragen: "Mikrofon izni isteniyor…",
  toestemmingUitleg: "Tarayıcın az sonra mikrofon izni isteyecek. İzin vermezsen sadece yazabilirsin.",
  microfoonTestLink: "Önce mikrofonunu test et",
  stemGaatMee: "Bu odada karşı taraf, çevirinin yanı sıra kendi sesini de duyar.",
  alleenChatMelding: "Bu görüşme yalnızca sohbettir. Mesajlarını yazar ve çeviriyi okursun; hiçbir şey sesli okunmaz.",
  verlooptOm: "Süre bitişi",
  nooitVasteKamer: "Hiçbir zaman, kalıcı oda",
  kamer: "Oda",
  tolkgesprek: "Tercümanlı görüşme",
  juisteKamer: "Doğru odadasın. Birazdan burada konuşmaya başlayabilirsin.",
  jij: "sen",
  deAnder: "karşı taraf",
  verbinden: "Bağlanıyor…",
  verbonden: "Bağlandı",
  verbindingKwijt: "Bağlantı kesildi. Tekrar deneniyor…",
  wachtenOpAnder: "İçeridesin. Karşı tarafın QR kodunu taratması bekleniyor.",
  allebeiInDeKamer: "İkiniz de odadasınız.",
  anderIsWeg: "Karşı taraf ayrıldı",
  anderSpreekt: "Karşı taraf konuşuyor…",
  jeKuntErNietIn: "Giriş yapamazsın",
  overgenomenTitel: "Başka bir cihazda devam ediliyor",
  overgenomenUitleg: "Bu görüşme az önce başka bir cihazda açıldı. Konuşmaya oradan devam ediyorsun.",
  terug: "Geri",
  geluidStaatUit: "Ses kapalı. Ekranın herhangi bir yerine dokun.",
  tikHier: "buraya dokun",
  bewaardTot: 'Şu saate kadar saklanır: {tijd}',
  bewaardVast: "Kalıcı oda. Mesajlar 30 gün saklanır.",
  spreekIn: "Konuş",
  luisteren: "Dinleniyor… durdurmak için dokun",
  uitschrijven: "Metne dökülüyor…",
  tijdOmTeVerbeteren: "Düzeltme süresi",
  altijdZelfVersturen: "Her zaman kendim kontrol edip göndereyim",
  jijVerstuurtZelf: "Kendin gönderiyorsun",
  uit: "kapalı",
  sec: "sn",
  vertalingMeteenAfspelen: "Çeviriyi hemen oynat",
  typHierJeBericht: "Mesajını buraya yaz…",
  stuur: "Gönder",
  geenOpnameMogelijk: "Bu tarayıcı ses kaydedemiyor. Yazarak devam edebilirsin.",
  verstaanAls: "Anlaşılan",
  tellerStaatStil: "sayaç durdu",
  versturen: "Gönder",
  wis: "Sil",
  jijZei: "sen dedin ki",
  vertaald: "çevrilen",
  duimOmhoog: "Bu doğru",
  duimOmlaag: "Bu yanlış",
  opnieuwProberenKnop: "Daha iyi bir modelle tekrar dene",
  opnieuwProberenBezig: "Tekrar çevriliyor…",
  duimTranscriptWoordenlijstUitnodiging: "Yanlış mı anlaşıldı? Kelime listesinde düzelt:",
  instellingenAanpassen: "Ayarları değiştir",
  geldtVoorJullieBeiden: "İkiniz için de geçerli",
  alleenVoorJou: "Sadece senin için",
  stuurMijnStemMee: "Kendi sesimi de gönder",
  verbeterSpelfouten: "Yazımdaki imla hatalarını düzelt",
  verbeterSpelfoutenUit: "Kapatıldığında, hatalar dahil tam olarak ne anlaşıldıysa o gösterilir.",
  alleenChat: "Yalnızca sohbet: ses yok, mikrofon yok",
  alleenChatUitleg: "İkiniz de yazıyorsunuz. Çeviri ve orijinal metin gösterilir; hiçbir şey sesli okunmaz.",
  aangepastDoorDeAnder: "Karşı taraf ayarları değiştirdi.",
  foutSpraak: "Çeviri hazır ancak ses çıkmadı.",
  foutSpraakQuota: "Bugünlük ses kotası doldu. Yazılı çeviri çalışmaya devam edecek; ses özelliği yarın dönecek.",
  foutBudgetKamer: "Bu görüşme sınırına ulaştı, bu yüzden çeviri şu an duraklatıldı. Görüşmeyi oluşturan kişi sınırı artırabilir; ardından hemen yeniden çalışır.",
  foutBudgetMaand: "Uygulamanın aylık bütçesi doldu. Yönetici bütçeyi ayarlayınca çeviri yeniden çalışacak.",
  foutTaal: "Bu dil seçilemez: İkiniz de aynı dili konuşuyor olurdunuz.",
  origineel: "orijinal",
  vertalen: "Çevriliyor…",
  vertalenMislukt: "Çeviri başarısız oldu.",
  opnieuwAfspelen: "Çeviriyi tekrar oynat",
  hoorDeAnder: "Karşı tarafın bunu nasıl söylediğini dinle",
  woordenlijst: "Kurtarıcı kelime listesi",
  woordenlijstUitleg: "Uygulama bir ismi veya terimi sürekli yanlış mı anlıyor? Ne kastedildiğini buradan tanımla.",
  hijHoort: "duyulan…",
  jijBedoelt: "kastettiğin…",
  ookVolgendeGesprekken: "Sonraki görüşmelerde de geçerli olsun — aksi takdirde sadece burada geçerlidir",
  voegToe: "Ekle",
  bezig: "İşleniyor…",
  lijstNietGeladen: "Liste yüklenemedi.",
  toevoegenMislukt: "Ekleme başarısız oldu.",
  verwijderenMislukt: "Silme başarısız oldu.",
  overal: "her yerde",
  verwijder: "Sil",
  overDitGesprek: "Bu görüşme hakkında",
  toon: "Çevirinin üslubu",
  sfeer: "Görüşmenin havası",
  jouwPlek: "Senin konumun",
  hoeHetWerkt: "Sunucu kaydını tek seferde metne döker ve çevirir. Kendi sesin de karşı tarafa iletilir.",
  kleinereTekst: "Daha küçük metin",
  grotereTekst: "Daha büyük metin",
  insprekenVerbergen: "Ses girişini gizle",
  insprekenTonen: "Ses girişini göster",
  toetsenbordVerbergen: "Klavyeyi gizle",
  toetsenbordTonen: "Klavyeyi göster",
  vormAutomatisch: "Otomatik",
  vormInformeel: "Senli benli",
  vormFormeel: "Sizli bizli",
  sfeerNeutraal: "Doğal",
  sfeerZakelijk: "İş odaklı",
  sfeerOfficieel: "Resmi",
  sfeerVriendschappelijk: "Arkadaş canlısı",
  sfeerPartner: "Partner",
  foutKamerVol: "Bu oda dolu. Odaya en fazla iki kişi girebilir.",
  plekBezetTitel: "Yerin dolu",
  plekBezetUitleg: "Bu konuşmada senin tarafında, senin dilinde biri zaten var. Genelde bu sensin: konuşma başka bir cihazda veya başka bir sekmede hâlâ açık. Orada kapat ve tekrar dene. Yerin boşalması bazen bir buçuk dakika sürer.",
  plekBezetWissel: "Bu sen misin? Konuşmayı bu cihaza almak için WISSEL yaz. Diğer cihaz o zaman kapanır.",
  plekBezetKnop: "Bu cihaza al",
  foutKamerVerlopen: "Bu odanın süresi dolmuş veya oda kapatılmış.",
  foutKamerOnbekend: "Böyle bir oda yok.",
  foutPinNodig: "Bu oda için bir PIN kodu gerekiyor.",
  foutPinFout: "Bu PIN kodu yanlış.",
  foutProtocol: "Uygulama ve sunucu birbiriyle anlaşamadı. Sayfayı yenile.",
  foutMicroGeweigerd: "Mikrofon iznini reddettin. Adres çubuğundaki kilit simgesine tıklayarak izin ver.",
  foutGeenMicro: "Mikrofon bulunamadı. Bir mikrofon bağlayıp tekrar dene.",
  foutMicroInGebruik: "Mikrofon başka bir program tarafından kullanılıyor. O programı kapatıp tekrar dene.",
  foutGeenHttps: "Mikrofon sadece güvenli bağlantılarda çalışır. Bu sayfayı https üzerinden aç.",
  foutMicroOnbekend: "Mikrofon başlatılamadı.",
  foutNietsOpgenomen: "Hiçbir şey kaydedilmedi. Mikrofonun açık mı?",
  foutNietsGehoord: "Ses duyulmadı. Mikrofonun açık mı ve yeterince yüksek sesle konuşuyor musun?",
  foutOpnameTeLang: "Bu kayıt çok uzun. Daha kısa parçalar halinde konuş.",
  foutMicroGedempt: "Mikrofonun sessize alınmış. Sesi açıp tekrar dene.",

  // --- microfoontest ---
  micTitel: "Mikrofon testi",
  micOnderschrift: "Arka arkaya dört test, her biri beş saniye. Boyunca konuşmaya devam et.",
  micStart: "Testi başlat",
  micTest1: "1. Sadece tanıma",
  micTest2: "2. Sadece kayıt",
  micTest3: "3. Birlikte — önce kayıt",
  micTest4: "4. Birlikte — önce tanıma",
  micFase1: "4 üzerinden 1: sadece tanıma — kısa bir cümle söyle",
  micFase2: "4 üzerinden 2: sadece kayıt — konuşmaya devam et",
  micFase3: "4 üzerinden 3: önce kayıt, sonra tanıma — konuşmaya devam et",
  micFase4: "4 üzerinden 4: önce tanıma, sonra kayıt — konuşmaya devam et",
  micKlaar: "bitti",
  micGehoord: "duyulan",
  micOpnameformaat: "Kayıt biçimi",
  micGeen: "yok",
  micBeveiligd: "Güvenli bağlantı",
  micJa: "evet",
  micNee: "HAYIR",
  micBrowser: "Tarayıcı",
  micGeenHttps: "https olmadan tarayıcı mikrofonu vermez. localhost üzerinde izin verilir.",
  micGeenHerkenning: "Bu tarayıcıda konuşma tanıma yok.",
  micZegIets: "bir şey söyle…",
  micWoordenBinnen: "kelimeler geliyor",
  micKonNietStarten: "başlatılamadı",
  micGeenRecorder: "Bu tarayıcı MediaRecorder bilmiyor.",
  micOpnemen: "kaydediliyor…",
  micNietsOpgenomen: "hiçbir şey kaydedilmedi",
  micGeenMicrofoon: "mikrofon yok",
  micOpnameEerst: "önce kayıt…",
  micHerkenningEerst: "önce tanıma…",
  micOpnameStarttNiet: "kayıt başlamadı",
  micSamenGelukt: "Birlikte. Kayıt {kb} kB.",
  micAlleenOpname: "Kayıt evet, tanıma hayır.",
  micAlleenHerkenning: "Tanıma evet, kayıt hayır.",
  micGeenVanBeide: "İkisi de değil.",
  micNetwerkFout: "Konuşma tanıma sunucuya ulaşamadı.",
  micAfgebroken: "Kayıt iptal edildi.",
  verslagTitel: "Görüşme tutanağı",
  verslagWie: "Kim",
  verslagOrigineel: "Orijinal",
  verslagVertaling: "Çeviri",
  verslagSpreker: "Konuşmacı {x}",
  verslagBerichten: "Mesajlar",
  verslagGemaaktOp: "Oluşturulma",
  verslagGeenOpname: "Birebir kayıt değildir.",
  verslagNootOrigineel: "“Orijinal”, uygulamanın konuşanı anladığı hâliyle metindir.",
  verslagNootCorrectie: "Yazım düzeltme açıktı: küçük yazım hataları düzeltildi.",
  verslagNootAangepast: "Konuşan kişi metni göndermeden önce değiştirebilirdi.",
  verslagGesproken: "sesli",
  verslagGetypt: "yazılı",
  verslagMislukt: "Çeviri başarısız oldu. Karşı taraf bu cümleyi kendi dilinde görmedi.",
  verslagNietKlaar: "Bu tutanak oluşturulduğunda çeviri henüz hazır değildi.",
  verslagVertrouwelijk: "Gizli.",
  verslagAlleenDeelnemers: "Bu tutanak özel bir görüşmenin içeriğini içerir ve yalnızca katılımcılar içindir.",
  verslagGewist: "Görüşmenin silinme zamanı: {tijd}. Bundan sonra bu tutanak yeniden oluşturulamaz.",
  verslagGewistVast: "Kalıcı oda: her mesaj gönderildikten 30 gün sonra silinir. Daha eski mesajlar bu kayıtta yer almaz.",
};
